import PropTypes from "prop-types"
import moment from "moment-timezone"

const Moment = ({ value, blank, format, tz }) => {
  if (value && tz) return moment(value).tz(tz).format(format)
  else if (value) return moment(value).format(format)
  else return blank
}

Moment.propTypes = {
  value: PropTypes.string,
  blank: PropTypes.string,
  format: PropTypes.string,
  tz: PropTypes.string
}

Moment.defaultProps = {
  value: null,
  blank: null,
  format: "DD MMMM YYYY",
  tz: null
}

export default Moment
